<template>
  <div id="crumbs" @mouseenter="openPresetMenu" @mouseleave="closePresetMenu">
    <div class="btn-group btn-group-sm" role="group" aria-label="First group">
      <button
        type="button"
        @mouseenter="openSubWSecond('sg')"
        @mouseleave="closeSubWSecond('sg')"
        v-if="CheckUserPermission([1, 2, 3, 4, 5, 12]) && auth.user.id !== 114"
        class="btn btn-nw not-ass"
      >
        <!--        @click="[openSubW('selling_group', 'sg'), whereClicked()]"-->

        <!--        :class="{-->
        <!--        'greyed-out':-->
        <!--        selectedMainTab === 'bn' || greyOutTag('sg', selectedMainTab)-->
        <!--        }"-->

        <!--        {{ statsLeadingActive ? 'SG' : kFormatterEar(statsLeadingActive) }}-->

        <!--        {{ // kFormatterEar(statsLeadingActive) }}-->
        <div v-tooltip.right="{ content: getContentForTooltip('sg') }">
          {{ kFormatterEar(statsSellingGroup) }}
        </div>

        <div class="bb-sub-menu" v-if="checkSubMenuMode('sg')">
          <div
            class="bb-sub-menu-reset"
            @click.stop="closeResetBtnW('sg')"
            v-tooltip="{ content: `Reset` }"
          >
            <div class="sg-color bb-item">
              <i class="fas fa-times"></i>
            </div>
            <div class="fake-column sg-color"></div>
          </div>
        </div>
        <div class="bb-sub-menu" v-if="checkIfSecondView('sg')">
          <div
            v-if="checkNumbersOfCalendarsSelected() === 1"
            class="bb-sub-menu-ms"
            @click.stop="
              mergeAllDates('sg', 'selling_group', shortCutsToBlocks)
            "
            v-tooltip="{
              content: `Use the same selected dates with this new selection`
            }"
          >
            <!--          @click.stop="filterMultipleTags('regular', 'ld')"-->

            <div class="sg-color bb-item">
              <div class="first-circle-tot"></div>
              <div class="second-circle-tot"></div>
              <div class="fake-column-tot sg-color"></div>
            </div>
          </div>
          <div
            class="bb-sub-menu-reset"
            @click.stop="filterSingleTag('selling_group', 'sg')"
            v-tooltip="{ content: `Disregard previous selections` }"
          >
            <div class="sg-color bb-item">
              <div class="first-circle first-circle-right"></div>
              <div class="second-circle second-circle-right"></div>
            </div>
            <div class="fake-column sg-color"></div>
          </div>
          <div
            class="bb-sub-menu-ms"
            @click.stop="filterMultipleTags('selling_group', 'sg')"
            v-tooltip="{ content: `Productivity` }"
          >
            <div class="sg-color bb-item">
              <div class="first-circle"></div>
              <div class="second-circle "></div>
              <div class="fake-column sg-color"></div>
            </div>
          </div>
        </div>
        <div class="bb-title-wrapper upper-title">
          <span class="">S.GROUP</span>
        </div>
        <div
          class="tags-dropdown"
          v-if="
            openTagDropdown &&
              mouseOver &&
              !checkSubMenuMode('sg') &&
              !checkIfSecondView('sg')
          "
        >
          <!--        <div class="tags-dropdown" v-if="false">-->
          <TagsDropdown
            :btnColors="btnColors"
            @presetTrigger="emitPresetTrigger"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import vClickOutside from "v-click-outside";
import {mapGetters, mapState} from "vuex";
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import TagsDropdown from "./TagsDropdown.component";
import { Globals } from "../../../../../../global_constants/constants";

export default {
  name: "NotAssNewBreadcrumbButton",
  components: {
    TagsDropdown
  },
  mixins: [UsersPermissionCheck, breadButtonsFunctionsUtil, calendarCheck],
  props: {
    ifCalendarSelected: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    leftEar: {
      type: Number,
      required: false
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    disabledOtherNew: {
      type: Boolean,
      required: false,
      default: () => false
    },
    disabledLeadingNew: {
      type: Boolean,
      required: false,
      default: () => false
    },
    disabledLoosingNew: {
      type: Boolean,
      required: false,
      default: () => false
    },
    disabledSellingGroup: {
      type: Boolean,
      required: false,
      default: () => false
    },
    stats: {
      type: Number,
      required: false
    },
    statsSellingGroup: {
      type: Number,
      required: false
    },
    statsLeadingNew: {
      type: Number,
      required: false
    },
    statsLoosingNew: {
      type: Number,
      required: false
    },
    showOverall: {
      type: Boolean,
      required: false
    },
    earRight: {
      type: Boolean,
      required: false,
      default: false
    },
    earLeft: {
      type: Boolean,
      required: false,
      default: false
    },

    queryObject: {
      type: Object
    },
    openNewFilteringDates: {
      type: String
    },
    dateHasentBeenChooseed: {
      type: Boolean
    },
    regCalPresetsStats: {
      type: Object
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      calendarForPreset: "REG",
      mouseOver: false,

      btnColors: {
        backgroundColor: "#1ac51a",
        color: "white"
      },
      openTagDropdown: false,
      flag: false,
      showPopup: false,
      intervals: [],
      openTimeFilterBtns: false,
      fromCal: false,
      slideBtn: {
        sg: false,
        on: false,
        ln: false,
        lsn: false
      },
      resetBtn: {
        sg: false,
        on: false,
        ln: false,
        lsn: false,
        nw: false
      },
      totalSum: ""
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "totalSumForCrumbBtn",
      "shortCutsToBlocks"
    ]),

    btnStyles() {
      return {
        "--bg-color": this.disabled ? "#546e7a" : this.bgColor,
        "--hover-on-disable": this.disabled ? "-3px" : "0px",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },

    btnSellingGroupStyles() {
      return {
        "--selling-group-bg-color": this.disabledSellingGroup
          ? "#546e7a"
          : "#009147",
        "--hover-on-disable": this.disabledSellingGroup ? "-3px" : "0px",
        "--font-weight": this.disabledSellingGroup ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnOtherNewStyles() {
      return {
        "--other-new-bg-color": this.disabledOtherNew ? "#546e7a" : "#009147",
        "--hover-on-disable": this.disabledOtherNew ? "-3px" : "0px",
        "--font-weight": this.disabledOtherNew ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnLeadingNewStyles() {
      return {
        "--selling-group-bg-color": this.disabledLeadingNew
          ? "#546e7a"
          : "#009147",
        "--hover-on-disable": this.disabledLeadingNew ? "-3px" : "0px",
        "--font-weight": this.disabledLeadingNew ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnLoosingNewStyles() {
      return {
        "--selling-group-bg-color": this.disabledLoosingNew
          ? "#546e7a"
          : "#009147",
        "--hover-on-disable": this.disabledLoosingNew ? "-3px" : "0px",
        "--font-weight": this.disabledLoosingNew ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },
  methods: {
    getContentForTooltip(tag) {
      return `${this.kFormatterEar(
        this.statsSellingGroup
      )} Active Leads waiting to be assigned to agents`;
      // if (this.checkIfCalendarSelected()) {
      //   // if(this.checkSubMenuMode(tag)){
      //   return `Total no answer ${this.stats} clients from ${this.generalQueryObject.last_modified_na_from} to ${this.generalQueryObject.last_modified_na_to}`;
      // } else {
      //   return `No answer ${this.stats} clients that are in the active group`;
      // }
    },
    closePresetMenu() {
      this.openTagDropdown = false;
      this.mouseOver = false;
    },
    openPresetMenu() {
      this.mouseOver = true;
      setTimeout(() => {
        if (this.mouseOver) {
          this.openTagDropdown = true;
        }
      }, Globals.ux.section.top_tag_menu.cal_presets_speed);
    },
    emitPresetTrigger(preset) {
      if (preset !== "ALL") {
        this.triggerPreset(this.calendarForPreset, preset);
      }
      if (preset) {
        this.openSubW("selling_group", "sg");
      }
      this.whereClicked();
    },
    outClose() {
      this.openTimeFilterBtns = false;
    },
    closeNewTimeFilterMenu() {
      this.openTimeFilterBtns = !this.openTimeFilterBtns;
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
    },

    kFormatterEar: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      } else {
        // return "SG";
        // return "NAS";
        return "0";
      }
    },
    kFormatterEarLeft: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      } else {
        // return "WSG";
        return "AGN";
      }
    },
    kFormatterBottomEarLeft: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      } else {
        // return "★";
        return "N";
        // return "BN"
      }
      // return "BN";
    },
    kFormatterBottomEarRight: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      } else {
        // return "LN";
        // return "★";
        return `N`;
      }
    },
    sendItUp(tempDate) {
      if (tempDate === "ALL") {
        this.$emit("filter_all");
      }

      this.flag = tempDate;
    },
    whereClicked() {
      this.openTimeFilterBtns = true;
      this.$emit("checkWhereClicked");
      // if (this.flag) {
      // } else {
      // //  this.openTimeFilterBtns = this.dateHasentBeenChooseed;
      // }
    }
  },
  watch: {
    totalSumForCrumbBtn: function() {
      this.totalSum = this.totalSumForCrumbBtn;
    },
    // dateHasentBeenChooseed:function () {
    //   this.flag = this.dateHasentBeenChooseed;
    //   if(this.flag){
    //     this.openTimeFilterBtns=true
    //   }
    // this.openTimeFilterBtns=openNewFilteringDates
    //     },
    leftEar: function() {
      if (this.leftEar > 0) {
        this.intervals.push(
          setInterval(() => {
            const yellow = "#fbc02d";
            const red = "#c62828";
            const grey = "#546e7a";
            this.yellow = grey;
            // let that = this;
            setTimeout(() => {
              this.yellow = yellow;
            }, 1500);
          }, 3000)
        );
      }
      if (this.leftEar < 1) {
        for (let i = 0; i < this.intervals.length; i++) {
          clearInterval(this.intervals[i]);
        }
        this.intervals = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$btnColor: #1ac51a;
$btnColorSG: #1ac51a;
$btnColorON: #1ac51a;
$btnColorLN: #1ac51a;

$btnColorChild: #009147;
$color: var(--bg-color);
$otherNewColor: var(--other-new-bg-color);
$sellingGroupColor: var(--selling-group-bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  /*margin-right: 10px;*/
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  /*width: 70px; //70px;*/
  line-height: 16pt;
  background: #1ac51a;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-weight: 500;
  /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
}

#crumbs a:hover {
  top: -3px;
}

.dot-right {
  height: 20px;
  /*width: 20px;*/
  border: 1px solid #009147;
  border-radius: 5px;
  color: #009147;
  /*border-radius: 50%;*/
  bottom: 20px;
  right: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-right:hover {
  /*background-color: #90a4ae;*/
}

.dot-left {
  height: 20px;
  width: 32px;
  border: 1px solid #009147;
  border-radius: 5px;

  color: #009147;
  font-weight: 400;
  bottom: 20px;
  left: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-left:hover {
  /*background-color: #90a4ae;*/
}

.dot-bottom-left {
  height: 20px;
  width: 20px;
  border: 1px solid #009147;
  border-radius: 5px;

  color: #009147;
  top: 20px;
  right: 51px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-bottom-left:hover {
  /*background-color: #90a4ae;*/
}

.dot-bottom-right {
  height: 20px;
  width: 20px;
  border: 1px solid #009147;
  border-radius: 5px;
  /*#fbc02d;*/
  color: #009147;
  /*border-radius: 50%;*/
  top: 20px;
  right: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-bottom-right:hover {
  /*background-color: #90a4ae;*/
}

.mainDiv {
  position: absolute;
  z-index: 1000001;
}

.btn-nw {
  font-size: 10px;
  color: #ffffff;
  background-color: $btnColor;
  border-color: $btnColor;
  transition: all 0.2s ease-in;
  /*min-width: 45px;*/
}

.btn-nw {
  color: #ffffff;
  background-color: $btnColor;
  border-color: $btnColor;
  outline: none;
  width: 100%;
  /*margin-right: 10px;*/
  border-radius: 5px !important;
  position: relative;
}

.btn-nw:hover,
.btn-nw:focus,
.btn-nw:active,
.btn-nw.active .open .dropdown-toggle.btn-nw {
  /*<!--color: #ffffff;-->*/
  /*<!--background-color: $btnColor;-->*/
  /*<!--border-color: $btnColor;-->*/
  /*<!--outline: none;-->*/
  z-index: 0 !important;
}

.btn-nw:hover {
  outline: none;
  z-index: 1 !important;
  cursor: default;
}

.slide-btn {
  position: absolute;
  top: 26px;
  background-color: inherit;
  width: 100%;
  left: 0px;
  border-radius: 0px 0px 0px 30px;
}

.reset-btn {
  position: absolute;
  top: -8px;
  right: 0px;
  color: #333;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  /*transform: scale(1.3);*/
  color: red;
}

.btn-nw:nth-of-type(2) {
  /*Selling group*/
  /*<!--background-color: $btnColorChild;-->*/
  background-color: #1ac51a;
  /* border-color: $btnColorChild;
        border-bottom-color: black;
        border-top-color: black; */
}

.btn-nw:nth-of-type(3) {
  /*Today call*/
  background-color: #1ac51a;
  /* border-color: #086837;
        border-bottom-color: #086837;
        border-top-color: #086837; */
}

.btn-nw:nth-of-type(4) {
  /* Auto Missed calls*/
  background-color: #1ac51a;
  /*background-color:white;*/
  //border-color: #03542b;
  //border-bottom-color: #03542b;
  //border-top-color: #03542b;
  font-size: 13px;
  /*color: yellow;*/
  padding: 0px;
  padding-left: 5px;
  padding-right: 5px;
}

.btn-nw:nth-of-type(4) i.fa-star {
  /*margin-left: 3px;*/
  /*padding-left: 5px;*/
  color: gold;
}

.btn-nw:nth-of-type(5) {
  /*background-color: #074124;*/
  background-color: #1ac51a;
  //border-color: #808080;
  //border-bottom-color: #074124;
  //border-top-color: #074124;
  //border-right-color: #074124;
  font-size: 13px;
  color: #ffffff;
  padding: 0px;
  padding-left: 5px;
  padding-right: 5px;
}

.btn-nw:nth-of-type(5) i.fa-star {
  color: black;
}

.btn-nw:first-child {
  /*width: 42px;*/
  /*width: 65px;*/
}

#crumbs .btn-group-sm {
  display: flex;
}

.btn-nw:hover {
  transform: scale(1.1);
}

span.bb-title {
  position: absolute;
  top: 25px;
  color: black;
  left: 0px;
  font-size: 8px;
  /*left:50%;*/
  margin-left: 5px;
}

div.bb-title-wrapper {
  //position: absolute;
  color: white;
  font-size: 8px;
  width: 100%;
  top: 25px;
  left: 0px;
  text-align: center;
}

.btn-nw-agent {
  /*width: 80px;*/
}

.upper-title {
  text-transform: uppercase;
}

.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.sg-color {
  background-color: $btnColorSG;
}

.on-color {
  background-color: $btnColorON;
}

.ln-color {
  background-color: $btnColorLN;
}

.lsn-color {
  background-color: black;
  color: white;
}

/*
    .bb-sub-menu-reset.lsn-color:after {
      background-color: white;
      content: " ";
      position: absolute;
      top: 20px;
      height: 5px;
      width: 8px;
      color: inherit;
      left: 6px;
      color: $btnColor;
      border-left: 1px solid black;
      border-right: 1px solid black;
    }

    .bb-sub-menu-ms.lsn-color:after {
      background-color: white;
      content: " ";
      position: absolute;
      top: 20px;
      height: 5px;
      width: 8px;
      color: white;
      left: 48px;
      border-left: 1px solid black;
      border-right: 1px solid black;
    }
    */
.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  cursor: pointer;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.nw-color {
  background-color: $btnColor;
}

.fake-column.lsn-color {
  height: 6px;
}

div.second-circle + .fake-column.lsn-color {
  height: 8px;
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.not-ass {
  font-size: 10px;

  transition: all 0.2s ease-in;

  color: #ffffff;
  outline: none;
  width: 100%;
  /*margin-right: 10px;*/
  border-radius: 5px !important;
  position: relative;
  background-color: #1ac51a;
  //border-color: $btnColorChild;
  //border-bottom-color: black;
  //border-top-color: black;
}

.first-circle-tot {
  background-color: inherit;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
  border: 1px solid white;
}

.second-circle-tot {
  border: 1px solid white;
  background-color: inherit;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.fake-column-tot {
  width: 8px;
  /*height: 10px;*/
  height: 23px;
  margin-left: 6px;
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}
</style>
